import Images from "../Assets/Images";
import React from 'react';
import {Link} from "react-router-dom";
import Strengths from "./Strengths";

export default function Professional () {
    return(
        <div>
            <section className="flex flex-col gap-4">
                <div className="flex flex-col md:flex-row items-center justify-center gap-3">
                    <img
                        src={Images.Personal.headshot2.src}
                        alt="headshot"
                        className="w-36 h-36 md:w-48 md:h-48 rounded-full object-cover object-top shadow-lg"
                    />
                    <p className=" text-center lg:max-w-[25vw]">I’m a developer who enjoys building user-focused solutions. I value clean and maintainable code where simplicity always beats complexity. Solving problems through logical reasoning is what truly drives me as a developer.</p>
                </div>
            </section>

            {/* Tech-stack Section */}
            <Strengths/>


            {/* Experience Section */}
            <section>
                <h2 className="text-3xl sm:text-3xl font-semibold mt-10 text-center">Experience</h2>

                <div className="space-y-6">
                    {/* SCOPR BV */}
                    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-5 hover:shadow-md transition">
                        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-2">
                            <h3 className="text-lg font-bold text-stone-800">Intern</h3>
                            <span className="text-sm text-gray-500">Nov 2024 – Jul 2025</span>
                        </div>
                        <p className="text-sm text-gray-600 font-medium">SCOPR BV</p>
                        <p className="text-gray-700 mt-2">
                            Helped develop an AI-powered renovation cost reporting tool.
                        </p>
                    </div>

                    {/* Operational Manager */}
                    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-5 hover:shadow-md transition">
                        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-2">
                            <h3 className="text-lg font-bold text-stone-800">Operational Manager</h3>
                            <span className="text-sm text-gray-500">Jan 2022 – Apr 2023</span>
                        </div>
                        <p className="text-sm text-gray-600 font-medium">Rhines International B.V.</p>
                        <p className="text-gray-700 mt-2">
                            Improved workflows and adopted digital tools to optimize processes.
                        </p>
                    </div>

                    {/* Allround Employee */}
                    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-5 hover:shadow-md transition">
                        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-2">
                            <h3 className="text-lg font-bold text-stone-800">Allround Employee</h3>
                            <span className="text-sm text-gray-500">Jan 2017 - Jan 2022</span>
                        </div>
                        <p className="text-sm text-gray-600 font-medium">Rhines International B.V.</p>
                        <p className="text-gray-700 mt-2">
                            Gained analytical and problem-solving skills by handling diverse technical and operational challenges.
                        </p>
                    </div>

                    {/* Customer Service */}
                    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-5 hover:shadow-md transition">
                        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-2">
                            <h3 className="text-lg font-bold text-stone-800">Customer Service</h3>
                            <span className="text-sm text-gray-500">Sep 2015 - Jan 2017</span>
                        </div>
                        <p className="text-sm text-gray-600 font-medium">Rhines International B.V.</p>
                        <p className="text-gray-700 mt-2">
                            Developed strong communication and troubleshooting skills.
                        </p>
                    </div>
                </div>
            </section>

            {/* Languages Section */}
            <section className="mt-10">
                <h2 className="text-3xl sm:text-3xl font-semibold mb-6 text-center">Languages</h2>
                <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
                        <span className="px-3 py-1 bg-gray-200 rounded-full text-sm sm:text-base font-medium">
                            Dutch (Native)
                        </span>
                    <span className="px-3 py-1 bg-gray-200 rounded-full text-sm sm:text-base font-medium">
                            English (Fluent)
                        </span>
                    <span className="px-3 py-1 bg-gray-200 rounded-full text-sm sm:text-base font-medium">
                            French (Beginner - Intermediate)
                        </span>
                </div>
            </section>

            {/* Contact CTA */}
            <section className="text-center mt-12">
                <Link
                    to="/contact"
                    className="px-6 py-3 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-500 transition"
                >
                    Get in Touch
                </Link>
            </section>
        </div>

    )

}